module.exports = __webpack_public_path__ + "img/1567772796.7d4e4813.jpg";